function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _ts_generator(thisArg, body) {
    var f, y, t, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  query getTags {\n    Tags {\n      name\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  query getAdminTags($where: Tags_bool_exp, $offset: Int, $limit: Int) {\n    Tags(offset: $offset, limit: $limit, where: $where) {\n      name\n      VersionTags_aggregate {\n        aggregate {\n          count\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  mutation addTag($name: String!) {\n    insert_Tags(objects: { name: $name }) {\n      affected_rows\n      returning {\n        name\n      }\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  mutation changeTagName($where: Tags_bool_exp!, $name: String!) {\n    update_Tags(where: $where, _set: { name: $name }) {\n      affected_rows\n      returning {\n        name\n      }\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  mutation deleteTag($name: String!) {\n    delete_Tags(where: { name: { _eq: $name } }) {\n      affected_rows\n    }\n  }\n"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
import { gql } from "graphql-request";
import { useMutation, useQuery } from "./useGraphQLApi";
var GET_TAGS_QUERY = gql(_templateObject());
var GET_ADMIN_TAGS_QUERY = gql(_templateObject1());
var ADD_TAG_MUTATION = gql(_templateObject2());
var CHANGE_TAG_MUTATION = gql(_templateObject3());
var DELETE_TAG_MUTATION = gql(_templateObject4());
export var useTags = function(params) {
    var _useQuery = useQuery(GET_TAGS_QUERY, params), data = _useQuery.data, error = _useQuery.error, isValidating = _useQuery.isValidating;
    return {
        data: data,
        error: error === null || error === void 0 ? void 0 : error.message,
        loading: isValidating
    };
};
export var useAdminTags = function(params, options) {
    var _useQuery = useQuery(GET_ADMIN_TAGS_QUERY, params, options), data = _useQuery.data, error = _useQuery.error, isValidating = _useQuery.isValidating, mutate = _useQuery.mutate;
    var addTagRequest = useMutation(ADD_TAG_MUTATION);
    var deleteTagRequest = useMutation(DELETE_TAG_MUTATION);
    var changeTagRequest = useMutation(CHANGE_TAG_MUTATION);
    var addTag = function(name) {
        return _async_to_generator(function() {
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            addTagRequest({
                                name: name
                            })
                        ];
                    case 1:
                        _state.sent();
                        mutate();
                        return [
                            2
                        ];
                }
            });
        })();
    };
    var changeTag = function(tagName, name) {
        return _async_to_generator(function() {
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            changeTagRequest({
                                name: name,
                                where: {
                                    name: {
                                        _eq: tagName
                                    }
                                }
                            })
                        ];
                    case 1:
                        _state.sent();
                        mutate();
                        return [
                            2
                        ];
                }
            });
        })();
    };
    var deleteTag = function(name) {
        return _async_to_generator(function() {
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            deleteTagRequest({
                                name: name
                            })
                        ];
                    case 1:
                        _state.sent();
                        mutate();
                        return [
                            2
                        ];
                }
            });
        })();
    };
    return {
        addTag: addTag,
        changeTag: changeTag,
        data: data,
        deleteTag: deleteTag,
        error: error === null || error === void 0 ? void 0 : error.message,
        loading: isValidating
    };
};

//# sourceMappingURL=useTags.js.map